import React from 'react';
import { Translate } from 'react-localize-redux';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import Flex from '@components/layout/flex';
import Button from '@components/actions/button';
import { CallHistoryMethodAction, push } from 'connected-react-router';
import {
  ReassignSplits,
  UpdateRequestOwnershipField,
} from '@webapp/store/ownership/action-creators';
import { Ownership } from '@services/ownership/types/ownership';
import { ValidOwnershipType } from '@services/ownership/types/valid-ownership-type';
import { SplitUpdate } from '@services/ownership/types/split-update';

interface BoxBottomProps {
  goToDashboard: () => CallHistoryMethodAction;
  updateRequestSplit: (
    ownershipId: string,
    split: number,
    trackId: string
  ) => UpdateRequestOwnershipField;
  reassignSplit: (
    ownershipId: ValidOwnershipType,
    split: SplitUpdate[],
    trackId: string,
    newOwnerShip: Ownership[]
  ) => ReassignSplits;
  onReassignSplitError: () => void;
  isRequest: boolean;
  lockPeriod: boolean;
  ownershipId: string;
  newSplit: number;
  trackIdState: string;
  tabActive?: 'recordings' | 'publishing';
  trackId: string;
  recordingOwnerships: Ownership[];
  publishingOwnerships: Ownership[];
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goToDashboard: () => dispatch(push('/dashboard')),
  updateRequestSplit: (ownershipId: string, split: number, trackId: string) =>
    dispatch(
      new UpdateRequestOwnershipField(trackId, ownershipId, 'split', split)
    ),
  reassignSplit: (
    ownershipId: ValidOwnershipType,
    split: SplitUpdate[],
    trackId: string,
    newOwnerShip: Ownership[]
  ) =>
    dispatch(
      new ReassignSplits(trackId, ownershipId, split, newOwnerShip, true)
    ),
});
export const BoxBottom: React.FC<BoxBottomProps> = ({
  goToDashboard,
  reassignSplit,
  onReassignSplitError,
  trackIdState,
  tabActive,
  trackId,
  ownershipId,
  isRequest,
  lockPeriod,
  newSplit,
  updateRequestSplit,
  publishingOwnerships,
  recordingOwnerships,
}) => {
  const handleCancel = () => {
    goToDashboard();
  };

  const handleChangeSplit = () => {
    if (isRequest && !lockPeriod) {
      updateRequestSplit(ownershipId, newSplit, trackIdState);
      return;
    }
    if (
      tabActive === 'recordings' &&
      recordingOwnerships.reduce(
        (memo, o) => memo + (o.requestedSplit || o.split) * 10 ** 10,
        0
      ) /
        10 ** 10 !==
        100
    ) {
      onReassignSplitError();
      return;
    }
    if (
      tabActive === 'publishing' &&
      publishingOwnerships.reduce(
        (memo, o) => memo + (o.requestedSplit || o.split) * 10 ** 10,
        0
      ) /
        10 ** 10 !==
        100
    ) {
      onReassignSplitError();
      return;
    }
    let newArrSplit =
      tabActive === 'recordings' ? recordingOwnerships : publishingOwnerships;
    let newOwnerShipSplitArr = newArrSplit.filter((splitArr) => !splitArr.id);
    newArrSplit = newArrSplit.filter((splitArr) => splitArr.id);
    let newUpdatedArrSplit = newArrSplit.map((splitData) => {
      return {
        ownershipId: splitData.id,
        split: splitData.requestedSplit || splitData.split,
      };
    });
    reassignSplit(
      tabActive === 'recordings' ? 'OWNER' : 'WRITER',
      newUpdatedArrSplit,
      trackIdState || trackId,
      newOwnerShipSplitArr
    );
  };

  return (
    <Flex
      gap={5}
      alignItems="center"
      style={{ width: '100%', marginTop: '10px' }}
    >
      <Button
        fullWidth
        buttonType="secondary"
        uppercase
        onClick={() => handleCancel()}
      >
        <Translate id="COMMON.CANCEL" />
      </Button>
      <Button
        fullWidth
        color="primary"
        uppercase
        onClick={() => handleChangeSplit()}
      >
        <Translate id="COMMON.SAVE" />
      </Button>
    </Flex>
  );
};

export default connect(null, mapDispatchToProps)(BoxBottom);
